<template>
    <div>
        <!--    Share Project Document Modal    -->
        <div class="modal fade" id="shareProjectDocumentModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true"  data-keyboard="false" data-backdrop="static" style="overflow-x:hidden !important;overflow-y:auto !important;">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Share Project Documents</h5>
                        <button type="button" class="close" aria-label="Close" @click="closeGenerateLinkModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div id="loadingoverlay">
                            <div class="cv-spinner">
                                <span class="spinner"></span>
                                <span class="text-white ml-4 text-xl ">Generating Shareable Link</span>
                            </div>
                        </div>
                        <div>
                            <label>Who can access files?</label>
                            <multiselect
                                :options="accessOptions"
                                v-model="selectedAccessOptions"
                                :disabled="updatingSharingLink"
                                :show-labels="false"
                                :multiple="false"
                                class="mb-2 cursor-pointer"
                                @select="changeAccessSelection"
                                label="name"
                                :allow-empty="false"
                            >
                            </multiselect>
                        </div>
                        <div v-if="selectedAccessOptions.id !== 'Do not share'" class="folderCheckBox">
                            <b-form-group
                                label="Select the folders you want to share"
                                v-slot="{ ariaDescribedby }"
                            >
                                <b-form-checkbox
                                    v-for="option in folders"
                                    v-model="selectedFolders"
                                    :key="option.id"
                                    :value="option.id"
                                    :aria-describedby="ariaDescribedby"
                                    name="flavour-3a"
                                    class="w-full text-sm mt-0 pt-0"
                                    size="sm"
                                    @change="selectFolders(option.id)"
                                >
                                    {{ option.name }}
                                </b-form-checkbox>
                            </b-form-group>
                        </div>
                        <div class="row" v-if="selectedAccessOptions.id == 'Do not share'">
                            <div class="col-md-12">
<!--                                <button type="button" class="btn btn-primary" @click="generateShareAbleLink()">Generate Link</button>-->
                                <button type="button" class="btn btn-primary" @click="listLinks()">View Previous Links</button>
                            </div>
                        </div>
                        <div class="row" v-if="selectedAccessOptions.id !== 'Do not share'">
                            <div class="col-md-6">
                                <button type="button" class="btn btn-primary" @click="listLinks()">View Previous Links</button>
                            </div>
                            <div :class="(selectedSharingLink)? 'col-md-6 text-right':'col-md-6 text-right'">
                                <button type="button" v-if="selectedSharingLink && selectedSharingLinkEdit" class="btn btn-primary" @click="updateShareAbleLink()">
                                    Update Permissions
                                </button>
                                <button type="button" v-if="selectedAccessOptions.is_contact && !selectedSharingLinkEdit" class="btn btn-primary" @click="sentMail()">
                                    <span v-if="sendingInvite"><i class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>Sending</span>
                                    <span v-else>Send Invite</span>
                                </button>
                                <button type="button" v-else-if="selectedAccessOptions.is_contact && selectedSharingLinkEdit" class="btn btn-primary" @click="sentMail(selectedSharingLink,true)">
                                    <span v-if="sendingInvite"><i class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>Sending</span>
                                    <span v-else>Re-Send Invite</span>
                                </button>

                                <button type="button" v-else-if="!selectedAccessOptions.is_contact && !selectedSharingLinkEdit" class="btn btn-primary" @click="generateShareAbleLink()">Generate Link</button>
                                <button type="button" v-else class="btn btn-primary" @click="copyLink()">Copy New Link</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--    List Share Project Document Modal    -->
        <div class="modal fade" id="listShareProjectDocumentModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true"  data-keyboard="false" data-backdrop="static" style="overflow-x:hidden !important;overflow-y:auto !important;">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Share Project Documents List</h5>
                        <button type="button" class="close" aria-label="Close" @click="closeListDocumentLinkModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row mb-3 customLinkListClass border-1" v-if="shareAbleLinks.length > 0" v-for="(shareAbleLinkObj, index) in shareAbleLinks">
                            <div class="col-md-1 text-sm text-center">
                                {{ index+1 }}
                            </div>
                            <div class="col-md-4 text-sm text-center" v-if="shareAbleLinkObj.access == 'link'">
                                Share with anyone
                            </div>
                            <div class="col-md-4 text-sm text-center" v-else-if="shareAbleLinkObj.access == 'contact'">
                                Share with company
                            </div>
                            <div class="col-md-4 text-sm text-center" v-else-if="shareAbleLinkObj.access == 'projectContact'">
                                Share with {{shareAbleLinkObjProjectContact(shareAbleLinkObj)}}
                            </div>
                            <div class="col-md-4 text-sm text-center" v-else>
                                Do not share
                            </div>
                            <div class="col-md-4 text-sm text-center" v-if="shareAbleLinkObj.folder_share == 'specificFolders'">
                                Shared specific folders
                            </div>
                            <div class="col-md-4 text-sm text-center" v-else>
                                Shared all folders
                            </div>
                            <div :class="'col-md-3 text-sm text-right p-0'">
                                <button class="btn btn-outline-primary text-sm text-center m-0 share-link-tooltip" @click="editSharingLink(shareAbleLinkObj)" data-toggle="tooltip" data-placement="top" title="Edit Share Link"><i class="fa fa-edit"></i></button>
                                <button class="btn btn-outline-warning text-sm text-center m-0 share-link-tooltip" v-if="shareAbleLinkObj.access != 'projectContact'" @click="copySpecificLink(shareAbleLinkObj.sharing_link)" data-toggle="tooltip" data-placement="top" title="Copy Share Link"><i class="fa fa-clipboard"></i></button>
                                <button class="btn btn-outline-danger text-sm text-center m-0 share-link-tooltip" @click="deleteSharingLink(shareAbleLinkObj)" data-toggle="tooltip" data-placement="top" title="Delete Share Link"><i class="fa fa-trash"></i></button>
                            </div>
                        </div>
                        <div class="row mb-3" v-if="shareAbleLinks.length == 0">
                            <div class="col-md-12 text-sm text-center">
                                No Link Is Generated Yet
                            </div>
                        </div>
<!--                        <div class="row">-->
<!--                            <div class="col-md-12">-->
<!--                                <button class="btn btn-primary" @click="openGenerateLinkModal()">Generate New Link</button>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import {shareProjectDocumentsOptions} from '../constants/constants.js';
import axios from "axios";
import Swal from "sweetalert2";

export default {
    name: "share-project-document",
    components: {Multiselect, shareProjectDocumentsOptions},
    props: ['project','externalEmailService'],

    data() {
        return {
            accessOptions: shareProjectDocumentsOptions,
            selectedAccessOptions: {'id': 'Do not share','name':'','is_project_first_contact': false,'is_contact':false},
            oldSelectedAccessOptions: {'id': 'Do not share','name':'','is_project_first_contact': false,'is_contact':false},
            shareAbleLink: null,
            shareAbleLinks: [],
            folders: [],
            shareFolderOption: 'allFolders',
            selectedFolders: [],
            selectedSharingLink: null,
            updatingAndCreating: true,
            updatingSharingLink: false,
            sendingInvite: false,
            selectedSharingLinkEdit: false,
        }
    },
    created() {

    },
    mounted() {
        this.getProjectFolders();
        this.getSharingLinks();
    },
    methods: {
        openModal(){
            $('#shareProjectDocumentModal').modal('show');
            this.getProjectFolders();
        },
        projectContacts(contacts){
            if (contacts.length > 0){
                this.accessOptions = [...shareProjectDocumentsOptions,...contacts];
            }
        },
        shareAbleLinkObjProjectContact(shareAbleLinkObj){
            let contactID = shareAbleLinkObj.project_first_contact_id ?? shareAbleLinkObj.project_contact_id;
            if(contactID){
                let contact = this.accessOptions.find(obj => obj.id === contactID);
                if (contact){
                    return contact.name;
                }
            }
            return 'Project Contact';
        },
        generateShareAbleLink(sentMail = false){
            this.$nextTick(() => {
                this.showLoader();
                let data = {
                    projectId: this.project,
                    access: this.selectedAccessOptions,
                    shareFolderOption: (this.selectedFolders.includes(0))? 'allFolders':'specificFolders',
                    selectedFolders: this.selectedFolders
                };

                axios.post(route('document-share.generate-project-document-shareable-link'), data).then(response => {
                    this.shareAbleLink = response.data.sharingLink;
                    this.selectedSharingLink = response.data.generatedLinkOBJ;
                    this.selectedSharingLinkEdit = true;
                    this.updatingAndCreating = false;
                    this.getSharingLinks();
                    this.hideLoader();
                    if (sentMail){
                        this.sendInvite();
                    }
                });
            });
        },
        regenerateShareAbleLink(){
            this.$nextTick(() => {
                this.showLoader();
                let data = {
                    projectId: this.project,
                    access: this.selectedAccessOptions,
                    shareFolderOption: (this.selectedFolders.includes(0))? 'allFolders':'specificFolders',
                    selectedFolders: this.selectedFolders
                };

                axios.post(route('document-share.generate-project-document-shareable-link'), data).then(response => {
                    this.shareAbleLink = response.data.sharingLink;
                    this.selectedSharingLink = response.data.generatedLinkOBJ;
                    this.selectedSharingLinkEdit = true;
                    this.updatingAndCreating = false;
                    this.getSharingLinks();
                    this.hideLoader();
                });
            });
        },
        getSharingLinks(){
            axios.post(route('document-share.get-project-document-shareable-link'), {projectId: this.project}).then(response => {
                this.shareAbleLinks = response.data.sharingLink;
            });
        },
        copyLink(){
            navigator.clipboard.writeText(this.shareAbleLink);
            this.getToast().fire({
                type: 'success',
                title: 'Sharing link copied'
            });
        },
        sentMail(selectedSharingLink = null,resent = false){
            if (resent && selectedSharingLink){
                this.deleteSharingLink(selectedSharingLink)
            }
            this.sendingInvite = true;
            this.generateShareAbleLink(true);
        },
        sendInvite(){
            this.sendingInvite = true;
            if (this.externalEmailService == 'true'){
                axios.post(route('document-share.send-mail-service-invite-project-document-shareable-link'), {
                    projectId: this.project,
                    email: this.selectedAccessOptions.email,
                    shareLink: this.shareAbleLink
                }).then(response => {
                    this.getToast().fire({
                        type: 'success',
                        title: 'Invite sent to contact'
                    });
                    this.sendingInvite = false;
                });
            }else {
                axios.post(route('document-share.send-mail-invite-project-document-shareable-link'), {
                    projectId: this.project,
                    email: this.selectedAccessOptions.email,
                    shareLink: this.shareAbleLink
                }).then(response => {
                    this.getToast().fire({
                        type: 'success',
                        title: 'Invite sent to contact'
                    });
                    this.sendingInvite = false;
                });
            }


        },
        changeAccessSelection(changeFolder = false){
            this.$nextTick(() => {
                let selectedID = this.selectedAccessOptions.id;
                if(selectedID == 'With company' && !this.selectedAccessOptions.is_contact && !this.selectedAccessOptions.is_project_first_contact && this.shareAbleLinks.length > 0){
                    this.selectedSharingLink = this.shareAbleLinks.find(obj => obj.access == 'contact');
                }else if(selectedID == 'Anyone with link' && !this.selectedAccessOptions.is_contact && !this.selectedAccessOptions.is_project_first_contact && this.shareAbleLinks.length > 0){
                    this.selectedSharingLink = this.shareAbleLinks.find(obj => obj.access == 'link');
                }else if(this.selectedAccessOptions.is_contact || this.selectedAccessOptions.is_project_first_contact && this.shareAbleLinks.length > 0){
                    this.selectedSharingLink = this.shareAbleLinks.find(obj => (obj.project_contact_id === selectedID || obj.project_first_contact_id === selectedID));
                }else {
                    this.selectedSharingLink = null;
                }

                if ((this.selectedSharingLink != 'undefined' && this.selectedSharingLink != '' && this.selectedSharingLink != null && !this.selectedAccessOptions.is_contact) || ((this.selectedSharingLink != 'undefined' || this.selectedSharingLink != '' || this.selectedSharingLink != null))) {
                    if (this.selectedSharingLink && 'sharing_link' in this.selectedSharingLink) {
                        this.selectedSharingLinkEdit = true
                        this.shareAbleLink = this.selectedSharingLink.sharing_link;
                    }

                    if (this.selectedSharingLink && 'folder_ids' in this.selectedSharingLink) {
                        if(this.selectedSharingLink.folder_ids && this.selectedSharingLink.folder_share == 'specificFolders' && !changeFolder){
                            this.shareFolderOption = this.selectedSharingLink.folder_share;
                            let tempFolderIds = JSON.parse(this.selectedSharingLink.folder_ids);
                            this.selectedFolders = tempFolderIds;
                        }else if(this.selectedSharingLink.folder_share == 'allFolders' && !changeFolder){
                            this.shareFolderOption = this.selectedSharingLink.folder_share;
                            this.selectedFolders = [0];
                        }
                    }

                    this.updatingAndCreating = false;
                }else {
                    this.updatingAndCreating = true;
                    this.shareFolderOption = 'allFolders';
                    this.selectedFolders = [0];
                }

                // if(this.updatingAndCreating && !this.selectedAccessOptions.is_contact && !this.selectedAccessOptions.is_project_first_contact){
                //     this.shareFolderOption = 'allFolders';
                //     this.selectedFolders = [0];
                //     // this.generateShareAbleLink();
                // }
            });
        },
        getProjectFolders(){
            axios.post(route('document-share.get-project-document-folders'), {projectId: this.project}).then(response => {
                this.folders = [{name: 'All folders', id: 0}, ...response.data.folders];
                this.selectedFolders = [0];
            });
        },
        closeGenerateLinkModal(){
            $('#shareProjectDocumentModal').modal('hide');
            this.selectedAccessOptions = {'id': 'Do not share','name':'','is_project_first_contact': false,'is_contact':false};
            this.oldSelectedAccessOptions = {'id': 'Do not share','name':'','is_project_first_contact': false,'is_contact':false};
            this.shareAbleLink = null;
            this.shareFolderOption = 'allFolders';
            this.selectedFolders = [];
            this.selectedSharingLink = null;
            this.updatingAndCreating = true;
            this.selectedSharingLinkEdit = false;
            this.updatingSharingLink = false;
        },
        closeListDocumentLinkModal(){
            $('#listShareProjectDocumentModal').modal('hide');
            this.closeGenerateLinkModal();
        },
        openGenerateLinkModal(){
            $('#listShareProjectDocumentModal').modal('hide');
            $('#shareProjectDocumentModal').modal('show');
        },
        copySpecificLink(link){
            navigator.clipboard.writeText(link);
            this.getToast().fire({
                type: 'success',
                title: 'Sharing link copied'
            });
        },
        editSharingLink(shareAbleLinkObj){
            this.selectedSharingLink = shareAbleLinkObj;
            this.selectedSharingLinkEdit = true;
            this.updatingSharingLink = true;
            if(shareAbleLinkObj.access == 'contact'){
                this.selectedAccessOptions = this.accessOptions.find(obj => obj.id === 'With company');
            }else if(shareAbleLinkObj.access == 'link'){
                this.selectedAccessOptions = this.accessOptions.find(obj => obj.id === 'Anyone with link');
            }else if(shareAbleLinkObj.access == 'projectContact'){
                let contactID = shareAbleLinkObj.project_contact_id ?? shareAbleLinkObj.project_first_contact_id
                this.selectedAccessOptions = this.accessOptions.find(obj => obj.id === contactID);
            }else{
                this.selectedAccessOptions = this.accessOptions.find(obj => obj.id === 'Do not share');
            }
            this.shareAbleLink = shareAbleLinkObj.sharing_link;
            this.shareFolderOption = shareAbleLinkObj.folder_share;
            if(shareAbleLinkObj.folder_ids && shareAbleLinkObj.folder_share == 'specificFolders'){
                let tempFolderIds = JSON.parse(shareAbleLinkObj.folder_ids);
                this.selectedFolders = tempFolderIds;
            }else if(shareAbleLinkObj.folder_share == 'allFolders'){
                this.selectedFolders = [0];
            }
            this.updatingAndCreating = false;
            this.openGenerateLinkModal();
        },
        updateShareAbleLink(){
            console.log(this.selectedSharingLink);
            this.$nextTick(() => {
                let data = {
                    projectId: this.project,
                    access: this.selectedAccessOptions,
                    shareFolderOption: (this.selectedFolders.includes(0))? 'allFolders':'specificFolders',
                    selectedFolders: this.selectedFolders,
                    selectedSharingLink: this.selectedSharingLink.id
                };
                axios.post(route('document-share.update-project-document-shareable-link'), data).then(response => {
                    this.shareAbleLink = response.data.sharingLink;
                    this.getToast().fire({
                        type: 'success',
                        title: 'Sharing link permission updated.'
                    });
                    this.getSharingLinks();
                });
            });
        },
        deleteSharingLink(shareAbleLinkObj) {
            let data = {
                selectedSharingLink: shareAbleLinkObj.id
            };
            axios.post(route('document-share.delete-project-document-shareable-link'), data).then(response => {
                this.shareAbleLink = response.data.sharingLink;
                this.getSharingLinks();
                this.getToast().fire({
                    type: 'success',
                    title: 'Sharing link deleted'
                });
            });
        },
        selectFolders(optionId){
            this.$nextTick(() => {
                if(optionId > 0){
                    this.selectedFolders = this.selectedFolders.filter(folder => folder > 0);
                }else{
                    this.selectedFolders = this.selectedFolders.filter(folder => folder == 0);
                }
                this.changeAccessSelection(true);
            });
        },
        listLinks(){
            this.updatingSharingLink = false;
            this.getSharingLinks();
            $(".share-link-tooltip").tooltip();
            $('#shareProjectDocumentModal').modal('hide');
            $('#listShareProjectDocumentModal').modal('show');
        },
        showLoader(){
            $("#loadingoverlay").fadeIn();
        },
        hideLoader(){
            $("#loadingoverlay").fadeOut();
        },
    },
}
</script>
<style scoped>
.shareDocumentRadioClass .col-form-label {
    font-weight: 400;
    margin-top: 0;
    padding-bottom: 0;
    font-size: 1rem;
}
.shareDocumentRadioClass {
    margin-top: 8px;
}
.shareDocumentRadioClass .custom-radio {
    margin-left: 10px !important;
}
input[type='radio']:checked:before{
    background: #01b1af !important;
}
.customLinkListClass {
    background: #d3d3d380;
    margin: 0 auto;
    display: flex;
    align-items: center;
    padding: 0;
    border-radius: 5px;
    overflow: hidden;
}
.folderCheckBox legend {
    font-weight: 400 !important;
}
.folderCheckBox .custom-control {
    margin-top: 0px !important;
}
#loadingoverlay{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    display: none;
    background: rgb(0 0 0 / 57%);
}

.cv-spinner {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px #ddd solid;
    border-top: 4px #2e93e6 solid;
    border-radius: 50%;
    animation: sp-anime 0.8s infinite linear;
}

@keyframes sp-anime {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(359deg);
    }
}
</style>
